import React from "react";
import i18n from "../../../i18n";
import Layout from "../../../components/layout/Layout";
import ComparePanel, { TargetValueType } from "../CompareValuePanel";
import { ArrayUtil, DateUtil } from "../../../util";
import ReportAction from "../../../actions/ReportAction";
import { StressTestSupportGraph } from "../../../constants/supportGraph";
import { StressGeneric } from "./index";
import { GraphDataMaker } from "../../../util/helper/graph";
import { MAX_RETURNING_TIME } from "../../../constants/limit";

export default (props)=><StressGeneric 
	typeKey={StressTestSupportGraph.Returning}
	subHeader={i18n.t("returning_user")}
	fetchMain={ReportAction.fetchStressReturning}
	mainReadKey='returning'
	getAutoSelectItem={(items)=>{
		return GraphDataMaker.returningTimeLabel(Object.keys(items)[0]);
	}}
/>;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/StressByReturning.js